import { render, staticRenderFns } from "./WorkProblems.vue?vue&type=template&id=347e9009&"
import script from "./WorkProblems.vue?vue&type=script&lang=js&"
export * from "./WorkProblems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports